import { AppProvider } from '@edx/frontend-platform/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Route, Routes } from 'react-router-dom';
import { FooterSlot } from '@edx/frontend-component-footer';

import CatalogHeader from './header/CatalogHeader';
import HomePage from './home/HomePage';
import CatalogPage from './catalog/CatalogPage';
import CourseAboutPage from './course-about/CourseAboutPage';
import NotFoundPage from './not-found-page/NotFoundPage';
import { ROUTES } from './routes';

const queryClient = new QueryClient();

const App = () => (
  <AppProvider>
    <QueryClientProvider client={queryClient}>
      <div className="d-flex flex-column min-dvh-100">
        <CatalogHeader />
        <main className="d-flex flex-column flex-grow-1">
          <Routes>
            <Route path={ROUTES.HOME} element={<HomePage />} />
            <Route path={ROUTES.COURSES} element={<CatalogPage />} />
            <Route path={ROUTES.COURSE_ABOUT} element={<CourseAboutPage />} />
            <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
          </Routes>
        </main>
        <FooterSlot />
      </div>
    </QueryClientProvider>
  </AppProvider>
);

export default App;
